import {
  Amount,
  Box,
  EditIcon,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
  TrashIcon,
} from '@razorpay/blade/components';
import React from 'react';

interface DeductionTableData {
  id: string;
  componentName: string;
  monthlyAmount: number;
}

interface DeductionsBreakdownTableProps {
  data: DeductionTableData[];
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  showActions?: boolean;
  isLoading?: boolean;
  isRefreshing?: boolean;
}

const DeductionsBreakdownTable = ({
  data,
  onEdit,
  onDelete,
  showActions = false,
  isLoading = false,
  isRefreshing = false,
}: DeductionsBreakdownTableProps) => {
  return (
    <Box borderRadius={'large'} overflow={'hidden'}>
      <Table
        data={{
          nodes: data,
        }}
        isLoading={isLoading}
        isRefreshing={isRefreshing}
        backgroundColor="transparent">
        {(tableData) => (
          <>
            <TableHeader>
              <TableHeaderRow>
                <TableHeaderCell>
                  <Text weight="semibold">Component</Text>
                </TableHeaderCell>
                <TableHeaderCell textAlign="right">
                  <Text weight="semibold">Monthly</Text>
                </TableHeaderCell>
                {showActions && (
                  <TableHeaderCell textAlign="right">
                    <Text weight="semibold">Action</Text>
                  </TableHeaderCell>
                )}
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row) => (
                <TableRow key={row.id} item={row}>
                  <TableCell>
                    <Text>{row.componentName}</Text>
                  </TableCell>
                  <TableCell textAlign="right">
                    <Amount value={row.monthlyAmount} currency="INR" />
                  </TableCell>
                  {showActions && (
                    <TableCell textAlign="right">
                      <Box display="flex" gap="spacing.5">
                        {onEdit && (
                          <Link
                            icon={EditIcon}
                            onClick={() => onEdit(row.id)}
                            testID={`edit-${row.id}`}
                          />
                        )}
                        {onDelete && (
                          <Link
                            icon={TrashIcon}
                            onClick={() => onDelete(row.id)}
                            testID={`delete-${row.id}`}
                          />
                        )}
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </>
        )}
      </Table>
    </Box>
  );
};

export default DeductionsBreakdownTable; 